/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function FileZIP({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M4 .4A2.6 2.6 0 0 0 1.4 3v10A2.6 2.6 0 0 0 4 15.6h8a2.6 2.6 0 0 0 2.6-2.6V5.828a2.6 2.6 0 0 0-.761-1.838L11.01 1.162A2.6 2.6 0 0 0 9.172.4H4ZM2.6 3A1.4 1.4 0 0 1 4 1.6h1.9v1a1 1 0 0 0 1 1h1.5v1.3H6.9a1 1 0 0 0-1 1v1.7a1 1 0 0 0 1 1h1.5v1.3H6.9a1 1 0 0 0-1 1v1.7a1 1 0 0 0 1 1h1.5v.8H4A1.4 1.4 0 0 1 2.6 13V3Zm7 11.4H12a1.4 1.4 0 0 0 1.4-1.4V5.828a1.4 1.4 0 0 0-.41-.99L10.161 2.01a1.4 1.4 0 0 0-.99-.41H7.1v.8h1.5a1 1 0 0 1 1 1v1.7a1 1 0 0 1-1 1H7.1v1.3h1.5a1 1 0 0 1 1 1v1.7a1 1 0 0 1-1 1H7.1v1.3h1.5a1 1 0 0 1 1 1v1Z" clipRule="evenodd" /></svg>;
}
;